const HindiDetailData = {
    category: "हिंदी चुगली",
    title: "दिल्ली में पीएम मोदी की अहम बैठकें, विकास और शिक्षा योजनाओं पर रहेगा फोकस",
    description: "प्रधानमंत्री नरेंद्र मोदी आज दिल्ली में वरिष्ठ अधिकारियों के साथ महत्वपूर्ण बैठकों में शामिल होंगे। इन बैठकों में देश की विकास योजनाओं, शिक्षा सुधार और युवाओं के भविष्य से जुड़े मुद्दों पर चर्चा होगी।",
    image: "https://akm-img-a-in.tosshub.com/aajtak/images/story/202408/66cf8ca14af51-cabinet-meeting-28462478-16x9.jpg?size=948:533",
    author: {
        name: "BHavani",
        avatar: "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_640.png",
        date: "05 Jan 2026 09:21 IST"
    },
    whatsappText: "ताजा खबरों से अपडेट रहने के लिए हमारे Whatsapp Channel को Join करें",

    content: [{
            heading: "पीएम का व्यस्त कार्यक्रम",
            paragraph: "नई दिल्ली। प्रधानमंत्री नरेंद्र मोदी का आज (05 जनवरी) का दिन बेहद व्यस्त रहने वाला है। पीएम मोदी दिल्ली में कई अहम बैठकों में शामिल होंगे, जिनमें राष्ट्रीय विकास और नीतिगत मुद्दों पर चर्चा की जाएगी।"
        },
        {
            heading: "दिल्ली में उच्चस्तरीय बैठक",
            paragraph: "प्रधानमंत्री मोदी वरिष्ठ केंद्रीय मंत्रियों और अधिकारियों के साथ बैठक करेंगे। इस दौरान बुनियादी ढांचे, सड़क परियोजनाओं और देश के विकास कार्यों की समीक्षा होगी।"
        },
        {
            heading: "किसान और जनकल्याण योजनाएं",
            paragraph: "बैठकों में किसानों से जुड़ी योजनाओं और जनकल्याण कार्यक्रमों की प्रगति पर भी चर्चा की जाएगी। सरकार की प्राथमिकताओं और भविष्य की रणनीति पर मंथन होगा।"
        },
        {
            heading: "विकास और निवेश पर फोकस",
            paragraph: "प्रधानमंत्री मोदी निवेश को बढ़ावा देने और रोजगार सृजन से जुड़ी योजनाओं पर विशेष ध्यान देंगे। देश में उद्योग और स्टार्टअप्स को प्रोत्साहित करने पर जोर रहेगा।"
        },
        {
            heading: "नीतिगत और राजनीतिक रणनीति",
            paragraph: "राजनीतिक और प्रशासनिक स्तर पर आगामी योजनाओं को लेकर रणनीति बनाई जाएगी। विभिन्न राज्यों से जुड़े मुद्दों पर भी विचार-विमर्श किया जाएगा।"
        },
        {
            heading: "परियोजनाओं की समीक्षा",
            paragraph: "पीएम मोदी विभिन्न राष्ट्रीय परियोजनाओं की प्रगति की समीक्षा करेंगे और समयबद्ध क्रियान्वयन के निर्देश दे सकते हैं।"
        },
        {
            heading: "डिजिटल और सोशल मीडिया अपडेट",
            paragraph: "प्रधानमंत्री कार्यालय द्वारा योजनाओं और बैठकों से जुड़ी जानकारी सोशल मीडिया और डिजिटल माध्यमों के जरिए जनता तक पहुँचाई जाएगी।"
        }
    ]

};

export default HindiDetailData;